import { RouteConfig } from 'vue-router';
import SwResetPassword from './components/sw-reset-password.vue';

export const resetPasswordRoute: RouteConfig = {
  path: 'resetpassword',
  name: 'resetpassword',
  component: SwResetPassword,
};
